<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="打印机" prop="printerId">
            <el-input v-model="model.printerName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectPrinter.open()">
                选择
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="打印机组件" prop="moduleId">
            <el-input v-model="model.moduleName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectPrinterModule.open()">
                选择
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="物料" prop="materialNo">
            <el-input v-model="model.materialName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectMaterial.open()">
                选择
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="物料号" prop="materialNo">
            <el-input v-model="model.materialNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工序类型" prop="processType">
            <el-select v-model="model.processType" placeholder="请选择工序类型" clearable>
              <el-option
                  v-for="item in processTypeOptions"
                  :key="item"
                  :label="item"
                  :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <material-select ref="selectMaterial" @select="selectMaterial"/>
    <printers-modal ref="selectPrinter" @select="selectPrinter"/>
    <printers-module-modal ref="selectPrinterModule" @select="selectPrinterModule"/>

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import PrintersModal from "@/views/PrinterManage/PrinterBinding/components/PrintersModal";
  import PrintersModuleModal from "@/views/PrinterManage/PrinterBinding/components/PrintersModuleModal";

  export default {
    name: "PrinterBindingEdit",
    components: { MaterialSelect, PrintersModal, PrintersModuleModal },
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        processTypeOptions: ["包装", "预加工"], // 工序类型
        model: {
          pkid: "",
          printerId: "",
          printerName: "",
          moduleId: "",
          moduleName: "",
          materialNo: "",
          materialName: "",
          materialId: "",
          processType: "",
        },
        ruleValidate: {
          printerId: { required: true, message: "请选择打印机", trigger: "blur" },
          moduleId: { required: true, message: "请选择组件", trigger: "blur" },
          materialNo: { required: true, message: "请选择物料", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getData(row.pkid);
        } else {
          this.$reset("model");
        }
      },
      getData(pkid) {
        this.$http.get("basic", `printerMaterials/${pkid}`).then((res) => {
          if (res.success) {
            this.model = Object.assign(this.model, res.data);
          }
        });
      },

      // 添加物料
      selectMaterial(row) {
        this.model.materialId = row.id;
        this.model.materialNo = row.no;
        this.model.materialName = row.name;
      },
      // 选择打印机
      selectPrinter(row) {
        this.model.printerId = row.pkid;
        this.model.printerName = row.name;
      },
      // 选择组件
      selectPrinterModule(row) {
        this.model.moduleId = row.pkid;
        this.model.moduleName = row.name;
      },

      handleSubmit() {
        if (this.model.pkid > 0) {
          this.handleSubmitPut();
        } else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "printerMaterials", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitPost() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            console.log(this.model);
            this.$http
              .post("basic", "printerMaterials", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
